import React from "react";
import styles from '../styles/header.module.scss'
import Icon from "@/wmCompoments/Icon";
import { useGetBalanceData, useVenueRecycle } from "@/api/request";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";

const Header = () => {
    const { t } = useTranslation('transferCenter')
    const { data , isValidating , mutate} = useGetBalanceData()

    const { trigger , isMutating } = useVenueRecycle()

    const handleRecycle = async () => {
        try {
            await trigger({})
            await mutate()
            Toast.show(t('recycleSuccess'))
        } catch (error: any) {
            ErrorMessageDialog(error?.message ?? JSON.stringify(error))
        }
    }

    return <div className={styles.warpper}>
        <div>
            <span>{t('walletAmount')}</span>
        </div>
        <div className={styles.list}>

            <div className={styles.box}>
                <div className={styles.centerWalletWarpper}>
                    <span className={styles.title}>{t('centralWallet')}</span>
                    <div className={styles.recycle} onClick={()=>handleRecycle()}>
                        <Icon name={'icon-general-refresh'} className={ (isMutating || isValidating) ? styles.rotateInfinite : ''} />
                        <span>{t('oneClickRecycle')}</span>
                    </div>
                </div>
                <div className={styles.amount}>
                    <span >¥{data?.centerWalletBalance}</span>
                </div>
            </div>

            <div className={styles.box}>
                <div className={styles.centerWalletWarpper}>
                    <span className={styles.title}>{t('lockedAmount')}</span>
                </div>
                <div className={styles.amount}>
                    <span >¥{data?.lockedWalletBalance}</span>
                </div>
            </div>
            <div className={styles.box}>
                <div className={styles.centerWalletWarpper}>
                    <span className={styles.title}>{t('welfareCenter')}</span>
                </div>
                <div className={styles.amount}>
                    <span >¥{data?.centerWelfareBalance}</span>
                </div>
            </div>

        </div>
    </div>
}

export default Header